require("./bootstrap");

// require('./plugins/jquery/filterInputs');

const fa = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

// Check Browser cookie is enabled
if (!navigator.cookieEnabled) {
    document.getElementById("cookie_not_enabled").style.display = "block";
}

document.querySelector('title')

$(() => {
    $(document).on("input change", "input[type=\"number\"], input[data-type=\"numeric\"]", function(e) {
        // const key = e.key;
        const value = e.target.value;
        const enValue = value.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));
        const len = $(this).attr("maxlength");

        if(len && enValue.length > len) {
            e.target.value = enValue.slice(0, len);
        }else{
            e.target.value = enValue;
        }
    });

    // Add show password button to password inputs
    const show_password = $("<i class=\"icon pi-eye show_password\"></i>").on(
        "click",
        function() {
            const input = $(this).parent().prev();
            const type = input.attr("type");
            input.attr("type", type === "password" ? "text" : "password");
        }
    );
    const password_elm = $("input[type=password]");
    let in_input = password_elm.next("div.in_input");
    if (in_input.length > 0) {
        in_input.append(show_password);
    } else {
        in_input = $("<div class=\"in_input\"></div>");
        in_input.append(show_password);
        password_elm.after(in_input);
    }

    // format elemnts with number_format class
    $(".number_format").text((index, text) =>
        text.trim().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    );
    $("input.number_format").val((index, val) =>
        val.trim().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    );

    // remove , character when copy a formatted number
    document.querySelectorAll(".number_format").forEach((element) => {
        element.addEventListener("copy", (event) => {
            event.preventDefault();
            const selection = document
                .getSelection()
                .toString()
                .replace(/,/g, "");
            event.clipboardData.setData("text/plain", selection);
        });
    });

    $("form").on("submit", function() {
        $(this).addClass("loading");
    });

    // prevent clicking on loading submit buttons
    $("button.is_loading, form.loading button[type=submit]").on(
        "click",
        (event) => {
            event.preventDefault();
        }
    );

    $("select").on("change", function() {
        this.setCustomValidity("");
    });
});
